import React, { useState } from 'react';
import { Section } from './Section';
import { GiftIcon, ChevronDownIcon, SparklesIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const bonuses = [{
  num: '01',
  title: 'Playlist Curada por Emoción',
  desc: '6 playlists completas con BPM específico por tomo. La música correcta para cada clase sin buscar nada.',
  value: '$12.000',
  emoji: '🎵'
}, {
  num: '02',
  title: 'Ficha de Anamnesis Profesional',
  desc: 'Formulario completo, ficha express, ficha para adultos mayores y consentimiento informado editable. Listo para imprimir o compartir por WhatsApp.',
  value: '$9.000',
  emoji: '📋'
}, {
  num: '03',
  title: 'Guía de Variaciones en 3 Niveles',
  desc: '14 ejercicios clave del sistema en versión Fundacional, Estándar y Avanzada. Para dar la misma clase a cualquier grupo.',
  value: '$8.000',
  emoji: '📐'
}, {
  num: '04',
  title: 'Calendario Anual de Planificación',
  desc: '12 meses organizados semana a semana. Qué tomo, qué clase y qué meta cada semana del año. Sin decidir nunca más qué dar.',
  value: '$10.000',
  emoji: '📅'
}, {
  num: '05',
  title: 'Script de Primera Clase',
  desc: 'Qué decir exactamente en los 5 momentos clave de la primera clase para que el alumno nuevo se quede y pague el mes.',
  value: '$9.000',
  emoji: '🎤'
}];
export function Bonuses() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <Section className="bg-brand-light !py-8 md:!py-12" data-id="element-20" data-mp="2zf2bmgdbym7p">
      <div className="text-center mb-5 md:mb-8" data-id="element-21" data-mp="2zhoh8agnurna">
        <div className="inline-flex items-center gap-1.5 bg-white/10 text-brand-accent font-bold tracking-widest text-xs px-3 py-1 rounded-full border border-brand-accent/35 mb-3" data-id="element-22" data-mp="2uh96zrroe09j"><SparklesIcon className="w-3.5 h-3.5" data-id="element-23" data-mp="33h5o98bqjwuk" /> INCLUIDOS GRATIS</div>
        <h2 className="text-2xl md:text-4xl font-display font-black text-white mb-1.5" data-id="element-24" data-mp="33fun7g9od375">5 Bonos Estratégicos</h2>
        <p className="text-sm md:text-lg text-gray-200 font-medium" data-id="element-25" data-mp="nruk6l40pz3l">Sin costo extra con Stretching 360™</p>
      </div>

      <div className="max-w-3xl mx-auto space-y-2 mb-5 md:mb-8" data-id="element-26" data-mp="3cj6iqhppjyqy">
        {bonuses.map((bono, index) => {
        const isOpen = openIndex === index;
        return <motion.div key={bono.num} className="rounded-xl border overflow-hidden" style={{
          background: isOpen ? 'rgba(94,234,212,0.10)' : 'rgba(6,38,47,0.55)',
          borderColor: isOpen ? 'rgba(94,234,212,0.55)' : 'rgba(255,255,255,0.10)'
        }} data-id="element-27" data-mp="3hk3yyor5qipt" data-mpi={index}>
              <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full flex items-center justify-between px-4 py-3 md:px-5 md:py-3.5 text-left group" data-id="element-28" data-mp="2tsyhk55kjide">
                <div className="flex items-center gap-3" data-id="element-29" data-mp="32t3floovh4ew"><span className="text-lg md:text-xl" data-id="element-30" data-mp="32s245j3y2fwn">{bono.emoji}</span><span className="text-white font-display font-bold text-sm md:text-base" data-id="element-31" data-mp="32raaidtwqs90">{bono.title}</span></div>
                <div className="flex items-center gap-2" data-id="element-32" data-mp="2a4pfn3e83y0p"><span className="bg-white text-brand-dark text-[10px] font-black px-2 py-0.5 rounded-full" data-id="element-33" data-mp="2a3o6j4grpllm">GRATIS</span><motion.div animate={{
                rotate: isOpen ? 180 : 0
              }} data-id="element-34" data-mp="2f27q4y7w2lat"><ChevronDownIcon className="w-4 h-4 text-brand-accent" data-id="element-35" data-mp="27jrh9o7r0fvg" /></motion.div></div>
              </button>
              <AnimatePresence initial={false} data-id="element-36" data-mp="22kexjcc6box3">
                {isOpen && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.22
            }} className="overflow-hidden" data-id="element-37" data-mp="22ityb9ewzhsw"><div className="px-4 pb-3.5 md:px-5 md:pb-4 pl-[3.25rem] md:pl-[3.75rem]" data-id="element-38" data-mp="1tjp60kty4kp6"><span className="text-gray-400 text-xs line-through mb-1 inline-block" data-id="element-39" data-mp="1om72xb2m0zp3">{bono.value}</span><p className="text-gray-100 text-sm leading-relaxed" data-id="element-40" data-mp="1ju5ih1vag2nz">{bono.desc}</p></div></motion.div>}
              </AnimatePresence>
            </motion.div>;
      })}
      </div>

      <div className="bg-white rounded-xl p-3.5 md:p-4 text-center max-w-3xl mx-auto border border-brand-accent/30" data-id="element-41" data-mp="19wrdpziq92bi">
        <div className="text-brand-dark/70 text-xs md:text-sm mb-0.5" data-id="element-42" data-mp="15tmce0adv6og">VALOR TOTAL DE LOS 5 BONOS <span className="line-through" data-id="element-43" data-mp="10vb2xqo02y6r">$48.000</span></div>
        <div className="text-xl md:text-2xl font-display font-black text-brand-dark flex items-center justify-center" data-id="element-44" data-mp="10xxb9sipthq1"><GiftIcon className="w-5 h-5 mr-2 text-brand-accentHover" data-id="element-45" data-mp="34zec1i5hfwnr" /> GRATIS — Incluidos siempre</div>
      </div>
    </Section>;
}